import './product-message.scss';
import { BROWSE_URL } from '@app/routes';

const ProductMessage = (product = {}, type = 'message') => {
    if (type === 'bot') {
        return (
            `Edit this illustration
            <div class="product-message">
                <a href="${import.meta.env.VITE_URL}${BROWSE_URL.pathname}/${product?.id}" target="_blank">
                    ${product?.title}<br/>
                    <img style="width: 100%;" src="${import.meta.env.VITE_PRODUCTS_URL}/${product?.pathToBrowse}" class="product-message__img" />
                </a>
            </div>`
        );
    };

    return (`
        Edit this illustration<br/>
        <a href="${import.meta.env.VITE_URL}${BROWSE_URL.pathname}/${product?.id}" target="_blank">
            ${product?.title}<br/>
            <img style="width: 100%;" src="${import.meta.env.VITE_PRODUCTS_URL}/${product?.pathToBrowse}" />
        </a>
        <br/>
    `);
};

export default ProductMessage;